import { render, staticRenderFns } from "./AddToTabModal.vue?vue&type=template&id=0cfaa71e"
import script from "./AddToTabModal.vue?vue&type=script&lang=js"
export * from "./AddToTabModal.vue?vue&type=script&lang=js"
import style0 from "./AddToTabModal.vue?vue&type=style&index=0&id=0cfaa71e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports